import React from 'react';
import { Link, useParams } from 'react-router-dom';
import FloatingBubbles from '../components/FloatingBubbles';

const PAGES = {
  cgu: {
    title: "Conditions Générales d'Utilisation",
    emoji: '📋',
    content: [
      {
        title: "1. Objet",
        text: `Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation de la plateforme Agora, accessible à l'adresse social-agora.com. En accédant à la plateforme, vous acceptez sans réserve les présentes CGU.`
      },
      {
        title: "2. Description du service",
        text: `Agora est une plateforme sociale permettant à ses utilisateurs de partager des contenus, créer et rejoindre des projets collaboratifs, échanger des messages privés, et interagir avec d'autres membres de la communauté.`
      },
      {
        title: "3. Accès au service",
        text: `L'accès à certaines fonctionnalités nécessite la création d'un compte. L'utilisateur doit avoir au minimum 15 ans pour s'inscrire. En dessous de 15 ans, le consentement d'un représentant légal est requis. L'utilisateur est responsable de la confidentialité de ses identifiants de connexion.`
      },
      {
        title: "4. Comportement des utilisateurs",
        text: `L'utilisateur s'engage à ne pas publier de contenus illicites, haineux, diffamatoires, pornographiques ou portant atteinte aux droits de tiers. Il s'engage à ne pas harceler d'autres membres, à ne pas usurper l'identité d'autrui, et à ne pas tenter d'accéder de manière non autorisée aux systèmes de la plateforme.`
      },
      {
        title: "5. Contenu utilisateur",
        text: `L'utilisateur conserve les droits de propriété intellectuelle sur les contenus qu'il publie. En publiant sur Agora, il accorde à la plateforme une licence non exclusive d'utilisation, de reproduction et d'affichage de ces contenus dans le cadre du service. L'éditeur se réserve le droit de supprimer tout contenu contraire aux présentes CGU.`
      },
      {
        title: "6. Suspension et suppression de compte",
        text: `L'éditeur se réserve le droit de suspendre ou supprimer un compte en cas de violation des présentes CGU, sans préavis ni indemnité. L'utilisateur peut supprimer son compte à tout moment depuis la page de son profil.`
      },
      {
        title: "7. Limitation de responsabilité",
        text: `Agora est fourni "en l'état". L'éditeur ne garantit pas la disponibilité continue du service et ne saurait être tenu responsable des dommages directs ou indirects liés à l'utilisation de la plateforme. L'éditeur n'est pas responsable des contenus publiés par les utilisateurs.`
      },
      {
        title: "8. Modification des CGU",
        text: `L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications significatives. L'utilisation continue du service après modification vaut acceptation des nouvelles CGU.`
      },
      {
        title: "9. Droit applicable",
        text: `Les présentes CGU sont soumises au droit français. Tout litige relatif à leur interprétation ou exécution sera soumis aux tribunaux compétents français.`
      },
    ]
  },
  confidentialite: {
    title: "Politique de Confidentialité",
    emoji: '🔒',
    content: [
      {
        title: "1. Responsable du traitement",
        text: `Le responsable du traitement des données personnelles est GUERIN Maxime, éditeur de la plateforme Agora (social-agora.com). Contact : contact@social-agora.com`
      },
      {
        title: "2. Données collectées",
        text: `Lors de votre inscription et utilisation d'Agora, nous collectons les données suivantes :\n• Données d'identification : nom d'utilisateur, adresse email\n• Données de profil : biographie, photo de profil\n• Contenus publiés : posts, commentaires, messages, fichiers de projets\n• Données de connexion : date d'inscription, activité sur la plateforme`
      },
      {
        title: "3. Finalités du traitement",
        text: `Vos données sont collectées pour :\n• Gérer votre compte et vous identifier sur la plateforme\n• Permettre les fonctionnalités sociales (publications, projets, messages)\n• Assurer la sécurité et la modération de la plateforme\n• Améliorer nos services`
      },
      {
        title: "4. Base légale",
        text: `Le traitement de vos données repose sur :\n• L'exécution du contrat (CGU) pour la gestion de votre compte\n• Votre consentement pour les communications optionnelles\n• Notre intérêt légitime pour la sécurité de la plateforme`
      },
      {
        title: "5. Durée de conservation",
        text: `Vos données sont conservées pendant toute la durée d'activité de votre compte. En cas de suppression de compte, vos données personnelles sont supprimées dans un délai de 30 jours, à l'exception des données nécessaires au respect de nos obligations légales.`
      },
      {
        title: "6. Partage des données",
        text: `Vos données ne sont pas vendues à des tiers. Elles peuvent être partagées avec des prestataires techniques nécessaires au fonctionnement du service (hébergement : Hostinger). Ces prestataires agissent en tant que sous-traitants et sont soumis à des obligations de confidentialité.`
      },
      {
        title: "7. Vos droits (RGPD)",
        text: `Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :\n• Droit d'accès : obtenir une copie de vos données\n• Droit de rectification : corriger vos données inexactes\n• Droit à l'effacement : supprimer votre compte et vos données\n• Droit à la portabilité : recevoir vos données dans un format structuré\n• Droit d'opposition : vous opposer à certains traitements\n\nPour exercer ces droits, contactez-nous à : contact@social-agora.com`
      },
      {
        title: "8. Cookies",
        text: `Agora utilise un token d'authentification stocké localement (localStorage) pour maintenir votre session. Ce token est strictement nécessaire au fonctionnement du service et ne nécessite pas de consentement préalable. Aucun cookie publicitaire ou de traçage n'est utilisé.`
      },
      {
        title: "9. Sécurité",
        text: `Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.`
      },
      {
        title: "10. Contact et réclamation",
        text: `Pour toute question relative à vos données personnelles : contact@social-agora.com\n\nVous avez également le droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : www.cnil.fr`
      },
    ]
  },
  mentions: {
    title: "Mentions Légales",
    emoji: '⚖️',
    content: [
      {
        title: "Éditeur du site",
        text: `Nom : GUERIN Maxime\nStatut : Particulier\nAdresse email : contact@social-agora.com\nSite web : social-agora.com`
      },
      {
        title: "Directeur de la publication",
        text: `GUERIN Maxime`
      },
      {
        title: "Hébergement",
        text: `Le site social-agora.com est hébergé par :\nHostinger International Ltd\n61 Lordou Vironos Street, 6023 Larnaca, Chypre\nSite web : www.hostinger.fr`
      },
      {
        title: "Propriété intellectuelle",
        text: `L'ensemble des éléments constituant la plateforme Agora (design, logo, code source, textes) est la propriété exclusive de GUERIN Maxime, sauf mentions contraires. Toute reproduction, représentation ou exploitation, même partielle, est interdite sans autorisation préalable.`
      },
      {
        title: "Données personnelles",
        text: `La plateforme Agora collecte et traite des données personnelles conformément au Règlement Général sur la Protection des Données (RGPD). Pour plus d'informations, consultez notre Politique de Confidentialité.`
      },
      {
        title: "Cookies",
        text: `La plateforme utilise un système de token d'authentification (localStorage) strictement nécessaire à son fonctionnement. Aucun cookie publicitaire n'est utilisé.`
      },
      {
        title: "Limitation de responsabilité",
        text: `GUERIN Maxime ne saurait être tenu responsable des dommages directs ou indirects causés au matériel de l'utilisateur lors de l'accès au site, résultant de l'utilisation d'un matériel ne répondant pas aux spécifications techniques requises, ou de l'apparition d'un bug ou d'une incompatibilité.`
      },
      {
        title: "Droit applicable",
        text: `Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.`
      },
      {
        title: "Contact",
        text: `Pour toute question ou réclamation : contact@social-agora.com`
      },
    ]
  }
};

export default function Legal() {
  const { page } = useParams();
  const content = PAGES[page];

  if (!content) return (
    <div style={{ textAlign: 'center', padding: '80px', color: 'var(--muted)' }}>
      Page introuvable. <Link to="/" style={{ color: 'var(--blue)' }}>Retour à l'accueil</Link>
    </div>
  );

  return (
    <>
      <FloatingBubbles />
      <div style={{ position: 'relative', zIndex: 1, minHeight: '100vh' }}>
        <div style={{ background: 'rgba(235,244,255,0.85)', backdropFilter: 'blur(4px)', padding: '40px 20px 28px', borderBottom: '1px solid rgba(190,227,248,0.5)', textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '10px' }}>{content.emoji}</div>
          <h1 style={{ fontSize: '28px', fontWeight: 800, color: 'var(--dark)', letterSpacing: '-0.5px', marginBottom: '8px' }}>{content.title}</h1>
          <p style={{ fontSize: '13px', color: 'var(--muted)' }}>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '16px', flexWrap: 'wrap' }}>
            {[{ key: 'cgu', label: '📋 CGU' }, { key: 'confidentialite', label: '🔒 Confidentialité' }, { key: 'mentions', label: '⚖️ Mentions légales' }].map(p => (
              <Link key={p.key} to={`/legal/${p.key}`} style={{ padding: '6px 16px', borderRadius: '20px', fontSize: '13px', fontWeight: 600, background: page === p.key ? 'var(--blue)' : 'rgba(255,255,255,0.8)', color: page === p.key ? '#fff' : 'var(--text)', border: `1px solid ${page === p.key ? 'var(--blue)' : 'var(--border)'}`, textDecoration: 'none', transition: 'all .2s' }}>
                {p.label}
              </Link>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: '760px', margin: '0 auto', padding: '40px 20px 60px' }}>
          {content.content.map((section, i) => (
            <div key={i} style={{ marginBottom: '32px' }}>
              <h2 style={{ fontSize: '16px', fontWeight: 700, color: 'var(--dark)', marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid var(--border)' }}>{section.title}</h2>
              <p style={{ fontSize: '14px', color: '#2D3748', lineHeight: 1.8, whiteSpace: 'pre-line' }}>{section.text}</p>
            </div>
          ))}

          <div style={{ marginTop: '40px', padding: '16px 20px', background: 'rgba(255,255,255,0.8)', borderRadius: '12px', border: '1px solid var(--border)', textAlign: 'center' }}>
            <p style={{ fontSize: '13px', color: 'var(--muted)', margin: 0 }}>
              Des questions ? Contactez-nous à{' '}
              <a href="mailto:contact@social-agora.com" style={{ color: 'var(--blue)', fontWeight: 600 }}>contact@social-agora.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
